const ServicesTabsComponent = {

    data()
    {
        return {
            activeServiceTab: 'all',
            visibleServices: 10,

            services: window.departmentServices || [],
        };
    },

    methods: {

        setServiceTab( tab )
        {
            this.activeServiceTab = tab;
            this.visibleServices = 10;
        },

        showAllServices()
        {
            this.visibleServices = this.filteredServices.length;
        },

        isServiceVisible( index )
        {
            return this.visibleIndexes.has( index );
        },

    },

    computed: {

        filteredServices()
        {
            switch ( this.activeServiceTab ) {

                case 'services':

                    return this.services.filter(
                        service => service.is_analysis === 'N'
                    );

                case 'analysis':

                    return this.services.filter(
                        service => service.is_analysis === 'Y'
                    );

                default:

                    return this.services;

            }
        },

        visibleIndexes()
        {
            return new Set(
                this.filteredServices
                    .slice( 0, this.visibleServices )
                    .map( service => service.index )
            );
        },

        hasMoreServices()
        {
            return this.filteredServices.length > this.visibleServices;
        },

    },

};

window.ServicesTabsComponent = ServicesTabsComponent;